var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="substitutionParam--section">\n  ';
 if (section) { 
__p+='\n  <h3 class="toggle-content-trigger ';
 if (defaultOpen) { 
__p+='down';
 } 
__p+='" data-animation="no">'+
((__t=( section ))==null?'':_.escape(__t))+
'</h3>\n  ';
 } 
__p+='\n  <div id="section_'+
((__t=( sectionId ))==null?'':_.escape(__t))+
'" class="toggle-content substitutionParam" style="';
 if (defaultOpen) { 
__p+='display: block';
 } 
__p+='"></div>\n</div>\n';
}
return __p;
};
